// tunnelAssembler.js
var TunnelAssembler = pc.createScript('tunnelAssembler');

var startPos;
var endPos;
var counter;
var prevMargin;
var pps;
var ent;
var container;

//TunnelAssembler.attributes.add("cam", {type: "entity", title: "CameraEntity"});
TunnelAssembler.attributes.add("title", {type: "entity"});
TunnelAssembler.attributes.add("rtz", {type: "entity"});
TunnelAssembler.attributes.add("yce", {type: "entity"});
TunnelAssembler.attributes.add("twc", {type: "entity"});
TunnelAssembler.attributes.add("fin", {type: "entity"});
TunnelAssembler.attributes.add("can", {type: "entity"});
TunnelAssembler.attributes.add("rotSpd", {type: "number", title: "Cam Rotation Speed"});
TunnelAssembler.attributes.add("range", {type: "number", title: "TunnelRange"});
TunnelAssembler.attributes.add("mTime", {type: "number", title: "Time"});
TunnelAssembler.attributes.add("assets", {type: "entity", array: true});
TunnelAssembler.attributes.add("assets_p2", {type: "entity", array: true});

// initialize code called once per entity
TunnelAssembler.prototype.initialize = function() {
    this.container = this.app.root.findByName("tunnelContainer");
    this.container.setLocalEulerAngles(0,90,0);
    this.pps = this.range / this.mTime;
    this.startPos = this.entity.getPosition().z + this.range / 2;
    this.endPos = this.entity.getPosition().z - this.range / 2;
    this.prevMargin = 0;
    this.prevPos = this.startPos;
    this.app.timeScale = 1;
    this.tTween = null;
    this.app.on('buttonPressed', this.increaseTime, this);
    //this.increaseTime();
    this.theTime = 0;
    this.timeCounter = false;
    this.break1 = true;
    this.break2 = true;
    this.break3 = true;
    this.break4 = true;
    this.break5 = true;
    this.break6 = true;
    this.break7 = true;
    this.break8 = true;
    this.break9 = true;
    this.break10 = true;
    this.break11 = true;
};

TunnelAssembler.prototype.increaseTime = function(ent){
    console.log('buTtonbressed ' + ent);
    if(ent !== 'start'){
        return;
    }
    this.timeCounter = true;
    console.log('ict');
    var that = this;
    this.app.timeScale = 1;
    var data = {scl:0.5};
    this.tTween = this.entity.tween(data).to({scl:25}, 245.6, pc.ExponentialIn).on('update',function(){
        that.app.timeScale = data.scl;
    }).on('complete', function(){
     //that.fadeBack();
    }).start();
 //
};

TunnelAssembler.prototype.fadeBack = function(){
    console.log('ende echt finito');
    var ttime = {scale:25.0};
    var here = this;
    this.tTween.stop();
    this.entity.tween(ttime).to({scale:1}, 3, pc.Linear).on('update', function(){

        here.app.timeScale = ttime.scale;
    })
    .start();
};

TunnelAssembler.prototype.fadeStuff = function(ent,dir){

    var opac = {opacity: 0.0}; 
    //console.info(ent);
    mat = ent.model.model.meshInstances[0].material;

    if(dir == 'in'){
        console.log('dir:' + 'in');
        opac = {opacity: 0.0};
        ent.tween(opac).to({opacity: 1.0}, 0.25, pc.Linear).on('update',function(){
          //  console.log('in update');
          //  console.info(ent);
            mat.opacity = opac.opacity;
            mat.update();
        }).start();
    }
    if(dir == 'out'){
        opac = {opacity: 1.0};
        ent.tween(opac).to({opacity: 0.0}, 0.25, pc.Linear).on('update',function(){
            mat.opacity = opac.opacity;
            mat.update();
        }).start();
    }
};


// update code called every frame
TunnelAssembler.prototype.update = function(dt) {
    this.container.rotate(this.rotSpd,0,0);
    this.spawn();
    
    if(this.timeCounter){
        this.theTime += dt;
       // console.log('time: ' + this.theTime);
    }    
    
    if(this.theTime > 0.5){ //40.5
        if(this.break1){
            this.break1 = false;
            this.fadeStuff(this.rtz, 'in');
        }
    }

    if(this.theTime > 5){ //40.5
        if(this.break2){
            this.break2 = false;
            this.fadeStuff(this.rtz, 'out');
        }
    }

    if(this.theTime > 40){ //40.5
        if(this.break3){
            this.break3 = false;
            this.fadeStuff(this.title, 'in');
        }
    }
    if(this.theTime > 42.30){
        if(this.break4){
            this.break4 = false;
            this.fadeStuff(this.title, 'out');
        }
    }

    if(this.theTime > 79.75){
        if(this.break5){
            this.break5 = false;
            this.fadeStuff(this.yce, 'in');
        }
    }

    if(this.theTime > 84.30){
        if(this.break6){
            this.break6 = false;
            this.fadeStuff(this.yce, 'out');
        }
    }

    if(this.theTime > 85.0){
        if(this.break7){
            this.break7 = false;
            this.fadeStuff(this.twc, 'in');
        }
    }
    if(this.theTime > 84.30){
        if(this.break6){
            this.break6 = false;
            this.fadeStuff(this.yce, 'out');
        }
    }

    if(this.theTime > 85.0){
        if(this.break7){
            this.break7 = false;
            this.fadeStuff(this.twc, 'in');
        }
    }
    if(this.theTime > 89.60){
        if(this.break8){
            this.break8 = false;
            this.fadeStuff(this.twc, 'out');
        }
    }

    if(this.theTime > 93.0){
        if(this.break10){
            this.break10 = false;
            this.fadeStuff(this.can, 'in');
        }
    }
    if(this.theTime > 96.00){
        if(this.break11){
            this.break11 = false;
            this.fadeStuff(this.can, 'out');
        }
    }
    if(this.theTime > 1170.0){
        if(this.break9){
            this.break9 = false;
            this.fadeStuff(this.fin, 'in');
            console.log('lastscreen');
            this.fadeBack();
        }
    }

};

TunnelAssembler.prototype.spawn = function() {

if(this.prevPos > this.endPos){
    //randomly clone object at position of previous object + margin 
    var rnd = Math.floor(Math.random() * this.assets.length);
    var cEnt = this.assets[rnd].clone();
    var mPos = this.prevPos + this.prevMargin;
    //set and arrange
    cEnt.setPosition(0,0,mPos);
    cEnt.rotate(0,0,Math.floor(Math.random() * 6) * 60);
    
    this.container.addChild(cEnt);
    //get distance between actual object's z and destination needed for calculation of twntime - involving pixel per second (pps)
    var dst;
    if(mPos < 0){
        dst = (this.range/2) + (mPos * -1);
    } else {
        dst = this.range - (this.range / 2) - mPos;
    }
    
    var twnTime = dst / this.pps;
    //perform tween
    cEnt
    .tween(cEnt.getLocalPosition())
    .to({x:0,y:0, z: this.startPos}, twnTime, pc.Linear)
    .on('complete', function () {
        cEnt.destroy();
    })
    .start();

    //important value here - prevMargin aka marger entity position.z of the previous cloned object
    this.prevMargin = cEnt.children[0].getLocalPosition().z;
    this.ent = cEnt;
    }
    //also important the actual position of the latest cloned entity outside of condition to be up to date !!! 
    this.prevPos = this.ent.getLocalPosition().z;
};

// swap method called for script hot-reloading
// inherit your script state here
// TunnelAssembler.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/
// 
    /*
    var dynaPos;
    if(this.prevObj !== undefined){
        dynaPos = this.prevObj.getPosition().z + prevMargin;     
    } else {
        dynaPos = this.startPos;
    }
    
    */

